import {Card, Container, Text, Title} from "@mantine/core";
import {IconMoneybag} from "@tabler/icons-react";
import React from "react";
import {useStyles} from "../../models/styles/NotFoundStyle";
import {DashboardItemModel} from "../../models/components/DashboardItemModel";

export function DashboardItem(body: DashboardItemModel) {
    const { classes } = useStyles();
    return (
        <Container>
            <Card shadow="sm" padding="lg" radius="md" withBorder >
                {body.Icon}
                <Title className={classes.title}>{body.Title}</Title><Text color="dimmed" size="lg"
                                                                          align="center"
                                                                          className={classes.description}>
                {body.Description}
            </Text>
            </Card>
        </Container>
    )
}